import { ClientIdType } from '~/enums/ClientIdType';
import { User } from '~/types/User';

export const testHasClientId =
  (clientId: ClientIdType) =>
  (user: User): boolean => {
    return user.client === clientId;
  };
